<template>
  <div class="employer-claim-list">
    <div class="toolbar">
      <el-form :inline="true" size="small">
        <el-form-item label="投保公司"><el-input v-model.trim="policyholder" clearable placeholder="请输入投保公司" style="width:220px" @keyup.enter.native="search" /></el-form-item>
        <el-form-item label="保单号"><el-input v-model.trim="policyNo" clearable placeholder="请输入保单号" style="width:220px" @keyup.enter.native="search" /></el-form-item>
        <el-form-item label="出险员工"><el-input v-model.trim="employeeName" clearable placeholder="请输入出险员工姓名" style="width:220px" @keyup.enter.native="search" /></el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="search"
            >搜索</el-button
          >
          <el-button icon="el-icon-refresh" @click="reset">重置</el-button>
          <el-button type="success" icon="el-icon-download" @click="exportExcel"
            >导出 Excel</el-button
          >
          <el-button
            type="warning"
            icon="el-icon-plus"
            @click="openDialog('add')"
            >添加出险员工</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <el-table
      :data="rows"
      border
      stripe
      v-loading="loading"
      height="calc(100vh - 255px)"
    >
      <el-table-column
        prop="policyholder"
        label="投保公司"
        width="190"
        fixed="left"
        show-overflow-tooltip
      />
      <el-table-column prop="policy_no" label="保单号" width="180" />
      <el-table-column label="起保时间" width="165"
        ><template slot-scope="s">{{
          date(s.row.effect_date)
        }}</template></el-table-column
      >
      <el-table-column label="终保时间" width="165"
        ><template slot-scope="s">{{
          date(s.row.expire_date)
        }}</template></el-table-column
      >
      <el-table-column prop="driver_number" label="搬运工人(人)" width="120" />
      <el-table-column prop="clerk_number" label="文员内勤(人)" width="120" />
      <el-table-column prop="trucker_number" label="司机押运(人)" width="120" />
      <el-table-column label="保费(实付)" width="110" align="right"
        ><template slot-scope="s">{{
          money(s.row.pay_price)
        }}</template></el-table-column
      >
      <el-table-column prop="employee_name" label="出险人员姓名" width="120" />
      <el-table-column prop="employee_type" label="出险人员类型" width="120"
        ><template slot-scope="s">{{
          employeeType(s.row.employee_type)
        }}</template></el-table-column
      >
      <el-table-column label="出险时间" width="165"
        ><template slot-scope="s">{{
          date(s.row.accident_date)
        }}</template></el-table-column
      >
      <el-table-column
        prop="accident_note"
        label="事故描述"
        width="220"
        show-overflow-tooltip
      />
      <el-table-column label="估损金额" width="110" align="right"
        ><template slot-scope="s">{{
          money(s.row.amount_loss)
        }}</template></el-table-column
      >
      <el-table-column label="已赔付金额" width="110" align="right"
        ><template slot-scope="s">{{
          money(s.row.amount_paid)
        }}</template></el-table-column
      >
      <el-table-column label="案件状态" width="90"
        ><template slot-scope="s"
          ><el-tag :type="Number(s.row.status) === 1 ? 'success' : 'warning'">{{
            claimStatus(s.row.status)
          }}</el-tag></template
        ></el-table-column
      >
      <el-table-column label="操作" width="150"
        ><template slot-scope="s"
          ><el-button type="text" @click="openDialog('view', s.row.id)"
            >查看</el-button
          ><el-button type="text" @click="openDialog('edit', s.row.id)"
            >编辑</el-button
          ><el-button type="text" class="danger" @click="remove(s.row)"
            >删除</el-button
          ></template
        ></el-table-column
      >
    </el-table>
    <el-pagination
      class="pagination"
      :current-page="page"
      :page-size="pageSize"
      :page-sizes="[10, 15, 20, 25]"
      :total="total"
      layout="total, sizes, prev, pager, next, jumper"
      @size-change="changeSize"
      @current-change="changePage"
    />
    <claim-dialog
      :visible.sync="dialogVisible"
      :claim-id="currentId"
      :mode="dialogMode"
      @success="fetchData"
    />
  </div>
</template>

<script>
import dayjs from "dayjs";
import ExportJsonExcel from "js-export-excel";
import {
  deleteEmployerClaim,
  getEmployerClaimList
} from "@/api/employer-insurance";
import ClaimDialog from "./components/ClaimDialog.vue";
export default {
  name: "EmployerClaimList",
  components: { ClaimDialog },
  data() {
    return {
      loading: false,
      policyholder: "",
      policyNo: "",
      employeeName: "",
      rows: [],
      page: 1,
      pageSize: 15,
      total: 0,
      dialogVisible: false,
      dialogMode: "add",
      currentId: ""
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    params(paging = true) {
      const p = {};
      if (paging) Object.assign(p, { page: this.page, rows: this.pageSize });
      if (this.policyholder) p.policyholder = this.policyholder;
      if (this.policyNo) p.policy_no = this.policyNo;
      if (this.employeeName) p.employee_name = this.employeeName;
      return p;
    },
    async fetchData() {
      this.loading = true;
      try {
        const res = await getEmployerClaimList(this.params());
        this.rows = (res && res.rows) || [];
        this.total = Number((res && res.total) || this.rows.length);
      } finally {
        this.loading = false;
      }
    },
    search() {
      this.page = 1;
      this.fetchData();
    },
    reset() {
      this.policyholder = "";
      this.policyNo = "";
      this.employeeName = "";
      this.page = 1;
      this.fetchData();
    },
    changeSize(v) {
      this.pageSize = v;
      this.page = 1;
      this.fetchData();
    },
    changePage(v) {
      this.page = v;
      this.fetchData();
    },
    openDialog(mode, id) {
      this.dialogMode = mode;
      this.currentId = id || "";
      this.dialogVisible = true;
    },
    async remove(row) {
      await this.$confirm(
        `确定删除“${row.employee_name}”的出险记录吗？`,
        "删除确认",
        { type: "warning" }
      );
      const res = await deleteEmployerClaim({ id: Number(row.id) });
      if (!res) return;
      this.$message.success("删除成功");
      this.fetchData();
    },
    async exportExcel() {
      const res = await getEmployerClaimList(this.params(false));
      const list = (res && res.rows) || [];
      new ExportJsonExcel({
        fileName: "雇主险出险员工",
        datas: [
          {
            sheetName: "出险员工",
            sheetData: list.map(r => ({
              policyholder: r.policyholder,
              policy_no: r.policy_no,
              effect_date: this.date(r.effect_date),
              expire_date: this.date(r.expire_date),
              driver_number: r.driver_number,
              clerk_number: r.clerk_number,
              trucker_number: r.trucker_number,
              pay_price: this.money(r.pay_price),
              employee_name: r.employee_name,
              employee_type: this.employeeType(r.employee_type),
              accident_date: this.date(r.accident_date),
              accident_note: r.accident_note,
              amount_loss: this.money(r.amount_loss),
              amount_paid: this.money(r.amount_paid),
              status: this.claimStatus(r.status)
            })),
            sheetFilter: [
              "policyholder",
              "policy_no",
              "effect_date",
              "expire_date",
              "driver_number",
              "clerk_number",
              "trucker_number",
              "pay_price",
              "employee_name",
              "employee_type",
              "accident_date",
              "accident_note",
              "amount_loss",
              "amount_paid",
              "status"
            ],
            sheetHeader: [
              "投保公司",
              "保单号",
              "起保时间",
              "终保时间",
              "搬运工人(人)",
              "文员内勤(人)",
              "司机押运(人)",
              "保费(实付)",
              "出险人员姓名",
              "出险人员类型",
              "出险时间",
              "事故描述",
              "估损金额",
              "已赔付金额",
              "案件状态"
            ]
          }
        ]
      }).saveExcel();
    },
    date(v) {
      return v ? dayjs(v).format("YYYY-MM-DD HH:mm:ss") : "-";
    },
    money(v) {
      return v == null || v === "" ? "-" : (Number(v) / 100).toFixed(2);
    },
    employeeType(v) {
      return (
        { 1: "搬运工人", 2: "文员内勤", 4: "司机押运" }[Number(v)] || v || "-"
      );
    },
    claimStatus(v) {
      return { 0: "未知", 1: "已决", 2: "未决" }[Number(v)] || "未知";
    }
  }
};
</script>
<style lang="less" scoped>
.toolbar {
  margin-bottom: 12px;
}
.pagination {
  margin-top: 16px;
  text-align: right;
}
.danger {
  color: #f56c6c;
}
</style>
